module.exports = __webpack_public_path__ + "img/canvas-evening-normal.a09cb06a.jpg";